import React from 'react';

import styled from 'styled-components';

import ShopDataModalFeesReminder from './ShopDataModalFeesReminder';
import { useContractContext } from '../../../common/Contract/ContractContext';
import { getContractsSlug } from '../accommodations/helpers';
import ShopDataModalCategoryHeader from '../common/ShopDataModalCategoryHeader';
import { FIELD_CATEGORY } from '../constants';
import ShopDataModalContracts from '../contracts/ShopDataModalContracts';
import { useShopDataModalContext } from '../ShopDataModalContext';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShopDataModalFeesContractSelection = () => {
  const { currentLivingType, community, currentData, isCommunityCcrc, handleDataStatusChanged, setCurrentData } =
    useShopDataModalContext();
  const { contracts, keys: existingKeys, selectedKey, setKeys, setSelectedKey } = useContractContext();

  const onSaveNewContractsTab = (selection: string[]) => {
    const livingTypeKey = currentLivingType?.abv;

    const currentFeesData = currentData[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey] ?? {};
    const currentCareFeesData = currentData[FIELD_CATEGORY.FEES][livingTypeKey] ?? {};

    const newKey = selection.join('|');
    currentFeesData[newKey] = {};
    currentCareFeesData[newKey] = {};

    const finalFeesContractKeys = Object.keys(currentFeesData);
    const finalCareFeesContractKeys = Object.keys(currentCareFeesData);
    const newKeys = Array.from(new Set([...finalFeesContractKeys, ...finalCareFeesContractKeys]));
    setKeys(newKeys);
    setSelectedKey(newKeys[0]);
    setCurrentData((prevState: any) => {
      return {
        ...prevState,
        [FIELD_CATEGORY.FEES]: {
          ...prevState[FIELD_CATEGORY.FEES],
          [livingTypeKey]: {
            ...currentCareFeesData,
          },
        },
        [FIELD_CATEGORY.FEES_INCENTIVES]: {
          ...prevState[FIELD_CATEGORY.FEES_INCENTIVES],
          [livingTypeKey]: {
            ...currentFeesData,
          },
        },
      };
    });
    handleDataStatusChanged([FIELD_CATEGORY.FEES_INCENTIVES, FIELD_CATEGORY.FEES]);
  };

  const onContractTabEdit = (selection: string[]) => {
    const livingTypeKey = currentLivingType?.abv;

    if (selection.length) {
      const selectedContracts = community?.contracts.filter((c) => selection.includes(c.slug)) || [];
      const newKey = getContractsSlug(selectedContracts);
      const newKeys = existingKeys.filter((k) => k !== selectedKey);
      newKeys.push(newKey);

      setCurrentData((prevState: any) => {
        const updatedState = {
          ...prevState,
          [FIELD_CATEGORY.FEES_INCENTIVES]: {
            ...prevState[FIELD_CATEGORY.FEES_INCENTIVES],
            [livingTypeKey]: {
              ...prevState[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey],
              [newKey]: prevState[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey]?.[selectedKey as string],
            },
          },
          [FIELD_CATEGORY.FEES]: {
            ...prevState[FIELD_CATEGORY.FEES],
            [livingTypeKey]: {
              ...prevState[FIELD_CATEGORY.FEES][livingTypeKey],
              [newKey]: prevState[FIELD_CATEGORY.FEES][livingTypeKey]?.[selectedKey as string],
            },
          },
        };
        delete updatedState[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey][selectedKey as string];
        delete updatedState[FIELD_CATEGORY.FEES][livingTypeKey][selectedKey as string];
        return updatedState;
      });

      setKeys(newKeys);
      setSelectedKey(newKey);
    } else {
      setCurrentData((prevState: any) => {
        const updatedState = {
          ...prevState,
          [FIELD_CATEGORY.FEES_INCENTIVES]: {
            ...prevState[FIELD_CATEGORY.FEES_INCENTIVES],
            [livingTypeKey]: {
              ...prevState[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey],
            },
          },
          [FIELD_CATEGORY.FEES]: {
            ...prevState[FIELD_CATEGORY.FEES],
            [livingTypeKey]: {
              ...prevState[FIELD_CATEGORY.FEES][livingTypeKey],
            },
          },
        };
        delete updatedState[FIELD_CATEGORY.FEES_INCENTIVES][livingTypeKey][selectedKey as string];
        delete updatedState[FIELD_CATEGORY.FEES][livingTypeKey][selectedKey as string];
        return updatedState;
      });
      const updatedKeys = existingKeys.filter((k) => k !== selectedKey);
      setKeys(updatedKeys);
      setSelectedKey(undefined);
    }

    handleDataStatusChanged([FIELD_CATEGORY.FEES_INCENTIVES, FIELD_CATEGORY.FEES]);
  };

  const showAddContracts = !contracts.length && isCommunityCcrc;

  return (
    <HeaderContainer>
      <ShopDataModalFeesReminder />
      <ShopDataModalCategoryHeader borderless={!showAddContracts} label={'Fees'} />
      {isCommunityCcrc && (
        <ShopDataModalContracts onEditContractTab={onContractTabEdit} onSaveNewContractTabs={onSaveNewContractsTab} />
      )}
      {!showAddContracts && <div style={{ borderBottom: '1px solid var(--line-gray)' }} />}{' '}
    </HeaderContainer>
  );
};

export default ShopDataModalFeesContractSelection;
